import ArticlesTile from './ArticlesTile';

export default ArticlesTile;
